// #region Download Format Enum

export enum College {
    PolkCountyPublicSchools = 1,
    PolkStateCollege = 2,
    SoutheasternUniversity = 4,
    FloridaSouthernCollege = 5,
    SouthFloridaStateCollege = 6,
    KeiserUniversity = 7,
    FloridaPolytechnicUniversity = 8,
    WarnerUniversity = 9
}

// #endregion


// WEBPACK FOOTER //
// ./src/classes/College/CollegeEnum.ts